import script from "./SellerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SellerDashboard.vue?vue&type=style&index=0&id=1f2342a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2342a0"]])

export default __exports__